import { DatatableModule } from '@/components/datatable/datatable.module';
import { ErrorsLabelModule } from '@/components/errors-label/errors-label.module';
import { InputPasswordModule } from '@/components/input-password/input-password.module';
import { InputRadioGroupModule } from '@/components/input-radio-group/input-radio.module';
import { InputSelectAutocompleteModule } from '@/components/input-select-autocomplete/input-select-autocomplete.module';
import { InputSelectModule } from '@/components/input-select/input-select.module';
import { InputTextModule } from '@/components/input-text/input-text.module';
import { PasswordCriteriasModule } from '@/components/password-criterias/password-criterias.module';
import { DirectiveModule } from '@/directives/directive.modules';
import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  imports: [CommonModule, MaterialModule],
  declarations: [],
  exports: [
    MaterialModule,
    DatatableModule,
    ErrorsLabelModule,
    InputPasswordModule,
    InputTextModule,
    InputRadioGroupModule,
    InputSelectAutocompleteModule,
    InputSelectModule,
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    PasswordCriteriasModule,
    NgxLoadingModule,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class SharedModule {}
